<template>
  <div class="basic-info">
    <div class="title">
      <span>基本信息</span>
      <el-button v-if="!editable" type="primary" size="small" @click="onEditClick"> 编辑</el-button>
    </div>
    <div class="base" v-if="!editable">
      <div class="img">
        <img :src="baseInfo.connectorLogo" alt="" />
        <!-- <span> {{baseInfo.connectorName}}</span> -->
      </div>
      <div class="connectorName">
        {{ baseInfo.connectorName }}
        <div class="comment font">{{ baseInfo.connectorComment }}</div>
      </div>
      <div class="app font">关联应用:{{ baseInfo.appId === "0" ? "无" : "有" }}</div>
      <!-- <div class="url font">接口域名:</div>
    <div class="authority font">鉴权方式:</div> -->
    </div>
    <div class="baseForm" v-if="editable">
      <el-form ref="baseForm" :model="baseInfo" :rules="baseFormRules">
        <el-form-item label="连接器图标"> </el-form-item>
        <div class="img-upload">
          <image-upload ref="uploadImg" :multiple="false" :imageUrl="baseInfo.connectorLogo" @success="baseInfo.connectorLogo = $event" />
          <div class="text">请上传方形图片，尺寸大于 200*200px</div>
        </div>
        <el-form-item label="名称" prop="connectorName">
          <el-input v-model="baseInfo.connectorName" placeholder=""></el-input>
        </el-form-item>
        <el-form-item label="功能介绍">
          <el-input type="textarea" v-model="baseInfo.connectorComment" placeholder="暂无描述"></el-input>
        </el-form-item>
        <el-form-item label="关联应用">
          <el-select v-model="baseInfo.appId" placeholder="请选择关联应用">
            <el-option v-for="item in listingList" :key="item.id" :label="item.description" :value="item.id"> </el-option>
          </el-select>
        </el-form-item>
        <el-button type="primary" @click="onSave">保存</el-button>
        <el-button @click="onClose">取消</el-button>
      </el-form>
    </div>
    <div class="market-launch">
      <div class="title">
        <div class="text">
          <span>市场上架</span>
          <span class="des">触发事件和执行动作测试通过后的连接器可上架到连接器市场供其他企业使用</span>
        </div>
        <div class="btns">
          <el-button size="small" @click="onTestClick"> 测试</el-button>
          <el-button type="primary" size="small" @click="onPutOnClick"> 上架</el-button>
        </div>
      </div>
      <div class="edition">
        线上版本:
        <span class="edition-des">未上架到连接器市场</span>
      </div>
    </div>
    <div class="del-connector">
      <div class="title">
        <div class="text">
          <span>删除连接器</span>
          <span class="des">该连接器所有信息将被删除，后续创建连接流时将无法使用该连接器</span>
        </div>
        <div class="btns">
          <el-button type="danger" size="small" @click="onDelClick(id)"> 删除</el-button>
        </div>
      </div>
      <div class="tip-box">
        <i class="el-icon-warning"></i>
        <span>存在触发事件或执行动作的连接器不可删除，该操作不可逆，请谨慎操作。</span>
      </div>
    </div>
  </div>
</template>
<script>
import ConnectorApi from "@/apis/connector";
import ImageUpload from "../components/image-upload";
export default {
  name: "basic-info",
  props: {},
  components: { ImageUpload },
  data() {
    return {
      id: this.$route.query.id,
      editable: false,
      baseInfo: {},
      listingList: [],
      baseForm: {
        connectorName: "",
        appId: "",
        connectorLogo: "",
        connectorComment: "",
      },
      baseFormRules: {
        connectorName: [{ required: true, trigger: "blue" }],
      },
    };
  },
  created() {
    this.getConnectorInfoData();
  },
  methods: {
    async getConnectorInfoData() {
      const res = await ConnectorApi.getConnectorInfo(this.id);
      this.baseInfo = res;
    },

    onEditClick() {
      this.editable = !this.editable;
    },
    onTestClick() {},
    onPutOnClick() {},
    async onDelClick(id) {
      await this.$confirm("确定要删除这个连接器？", "提示", {
        type: "warning",
      });
      await ConnectorApi.deleteConnector(id);
      this.$message.success(`删除成功！`);
    },
    async onSave() {
      this.$refs.baseForm.validate(async (isOk) => {
        if (!isOk) return;
        const query = {
          id: this.id,
          connectorName: this.baseInfo.connectorName,
          appId: this.baseInfo.appId,
          connectorLogo: this.baseInfo.connectorLogo,
          connectorComment: this.baseInfo.connectorComment,
        };

        await ConnectorApi.editConnectorInfo(query);
        this.$message.success(`更新成功！`);
        this.editable = !this.editable;
      });
    },
    onClose() {
      this.editable = !this.editable;
    },
  },
};
</script>
<style scoped lang="scss">
.basic-info {
  height: 100%;
}
.title {
  //  height: 50px;
  display: flex;
  justify-content: space-between;
  font-size: 20px;
  font-weight: bold;
}
.title h1 {
  display: inline-block;
  color: #262626;
}
.base {
  height: 200px;
  border-bottom: 1px solid #f0f0f0;
  margin-top: 12px;
  position: relative;
  // display: flex;
  // flex-direction: column;
}

.market-launch {
  box-sizing: border-box;
  height: 165px;
  padding: 35px 0;
  border-bottom: 1px solid #f0f0f0;
}
.des {
  margin-left: 10px;
  font-size: 13px;
  font-weight: normal;
  color: #8c8c8c;
}
.edition {
  margin-top: 19px;
  font-size: 13px;
  color: #8c8c8c;
  .edition-des {
    font-size: 14px;
    color: #000;
  }
}

.del-connector {
  padding-top: 35px;
}
.tip-box {
  margin-top: 15px;
  height: 39px;
  border: 1px solid #ffebaa;
  font-size: 14px;
  color: #262522;
  background-color: #fffbe6;
}
.el-icon-warning {
  line-height: 39px;
  color: #faad14;
  margin: 0 8px 0 15px;
}
.img {
  width: 70px;
  height: 70px;
  display: inline-block;
  img {
    width: 100%;
    height: 100%;
  }
}
.connectorName {
  position: absolute;
  left: 94px;
  top: -2px;
  font-size: 18px;
}
.font {
  font-size: 14px;
  color: #747677;
  margin-top: 10px;
}
.baseForm {
  padding-bottom: 40px;
  border-bottom: 1px solid #f0f0f0;
}
.img-upload {
  display: flex;
  .text {
    width: 110px;
    height: 38px;
    font-size: 10px;
    margin-left: 12px;
    color: #a2a3a5;
  }
}
</style>
